import { CALILIO_NODE_ENV } from '@shared/constants/env';

export const IS_LOCAL_HOST = ((): boolean => {
  if (typeof window === 'undefined') return false;
  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname?.includes('devtunnels');
})();

/**
 * Generate app runtime env
 * If app env exists return it otherwise, return auto detect
 */
export const RUNTIME_ENV = (() => {
  const VAROSA_APP_ENV = import.meta.env.VAROSA_APP_ENV;

  if (VAROSA_APP_ENV) return VAROSA_APP_ENV;
  if (IS_LOCAL_HOST) return CALILIO_NODE_ENV.LOCAL;

  return import.meta.env.VAROSA_NODE_ENV;
})();
